import { RouteRecordRaw } from 'vue-router';

let routes: RouteRecordRaw[] = [
    {
        path: '/agentSubscriptions',
        name: 'agentSubscriptions',
        meta: { sideMenuLabel: "Incaricati" },
        component: () => import("./views/agentSubscriptions.vue")
    },
];

export default routes;